import * as React from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

const daysToMilliseconds = (days: number) => days * 24 * 60 * 60 * 1000;

/**
 * Хук использовал ли пользователь поисковую строку в последнее время
 */
export function useSearchStringUsed() {
  const { logger, config } = useApplicationContext();

  const searchStringKey = config.get<string>('uxfeedback.searchString.localStorageKey') || 'searchStringUsed';
  const expirationDays = config.get<number>('uxfeedback.searchString.expirationDays') || 3;

  const setSearchStringUsed = React.useCallback(() => {
    if (!window || !window.localStorage) {
      return;
    }

    const isSearchStringUsed = localStorage.getItem(searchStringKey);
    const currentSearchExpireDate = Date.now() + daysToMilliseconds(expirationDays);

    try {
      if (isSearchStringUsed) {
        const data = JSON.parse(isSearchStringUsed);
        data.expiresAt = data.currentSearchExpireDate;
        data.currentSearchExpireDate = currentSearchExpireDate;
        localStorage.setItem(searchStringKey, JSON.stringify(data));
      } else {
        localStorage.setItem(searchStringKey, JSON.stringify({ currentSearchExpireDate, expiresAt: null }));
      }
    } catch (error) {
      logger.warning('Failed to set search string used local storage flag', error);
    }
  }, [searchStringKey, expirationDays, logger]);

  return {
    setSearchStringUsed,
  };
}
